function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M16.738 7.265a5.922 5.922 0 01-1.74-4.167L20.898 9a5.89 5.89 0 01-4.16-1.735zm-2.548 5.191a10.191 10.191 0 00-1.186-1.458c-.45-.45-.939-.849-1.453-1.202l2.614-2.612a7.926 7.926 0 001.16 1.496c.45.451.951.833 1.482 1.157l-2.617 2.619zm-.22 6.518l-8.943-8.941a8.25 8.25 0 016.563 2.379 8.223 8.223 0 012.38 6.562zm9.737-9.994L15.021.293a.998.998 0 00-1.662.41 7.943 7.943 0 00-.054 4.512l-3.58 3.578a10.31 10.31 0 00-7.023-.328 1.001 1.001 0 00-.409 1.662l5.084 5.084-7.084 7.082a.999.999 0 101.414 1.414l7.084-7.082 5.084 5.082a1.002 1.002 0 001.662-.41 10.242 10.242 0 00-.342-7.019l3.578-3.579a7.972 7.972 0 004.524-.057 1 1 0 00.41-1.662z"
});

var SvgIconPin = function SvgIconPin(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _ref);
};

export default SvgIconPin;